/*

Prakash 29-10-2022 2698811066 Updated font size.
Ashraf 11/15/2022 2698966688 fixed account summary scroll
Suresh Peddavoora  02/09/2023 2698811066 Modified Styles for Header Components.
suresh peddavoora 03/02/2023 2698811066 New Ui changes
Prakash 02/06/2023 2698811066 Fixed chips issue in Account Summary

*/

import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useRef, useContext} from 'react';
import SelectTabContextProvider from '../components/SelectTabContext/SelectTabContext';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '15px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      // padding: '11.3px 7px',
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
}));

export default function ClientAccordion({
  windowName,
  windowCode,
  windowDescription,
  label,
  udw,
  children,
}) {
  const classes = useStyles();
  const {currentLabel, onChipClick, favouriteBlock} = useContext(SelectTabContextProvider);

  const myRef = useRef(null);

  const scrollToRef = (ref) => {
    const values= favouriteBlock ? 185 : 140;
    window.scrollTo({top: ref?.current?.offsetTop - values, behavior: 'smooth'});
  };
  const executeScroll = () => scrollToRef(myRef);
  useEffect(() => {
    if (onChipClick) {
      if (currentLabel === '0') {
        window.scrollTo({top: 0, behavior: 'smooth'});
      } else if (windowCode && currentLabel && currentLabel == windowCode) {
        executeScroll();
      } else if (
        (windowCode &&
          label?.length > 0 &&
          label[label.length - 1] === windowCode &&
          !currentLabel) ||
        label === windowCode
        // deepcode ignore DuplicateIfBody: <please specify a reason of ignoring this>
      ) {
        executeScroll();
      } else if (currentLabel && currentLabel === windowName) {
        scrollToRef(myRef);
      } else if (label?.length > 0 && label[label.length - 1] === windowName && !currentLabel) {
        executeScroll();
      }
    }
  }, [windowName, windowCode, label, currentLabel]);
  return (
    <div ref={myRef}>
      <div className={classes.root}>
        { children}
      </div>
    </div>
  );
}
